import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTop"] */ "/var/www/tmp.bua_frontend/src/components/BackToTop.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/components/CanvasComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/tmp.bua_frontend/src/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/tmp.bua_frontend/src/components/PageShuffle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MoreComponent"] */ "/var/www/tmp.bua_frontend/src/components/Partials/MoreComponent.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/Page.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/tmp.bua_frontend/src/styles/Home.module.scss");
